export function path(url) {
  let ar = url.split('?');
  return ar.length == 1 ? ar[0] : ar.slice(0, ar.length-1).join('?');
}

export function queryParse(url) {
  let query = {};
  let ar = url.split('?');
  let params = ar.length > 2 ? ar[ar.length-1]:ar[1];
  if (params) {
    params.split('&').forEach(it => {
      let kv = it.split('=');
      query[kv[0]] = decodeURIComponent(kv[1]);
    });
  }
  return query;
}

export function queryString(q) {
  let parts = Object.keys(q).map(k => k + '=' + encodeURIComponent(q[k]));
  return parts.join('&');
}

export function combine(url, query) {
  let p = path(url);
  let q = { ...queryParse(url), ...query };

  // remove null entries
  Object.keys(q).forEach(k => {
    let v = q[k];
    if (v === null) {
      delete q[k];
    }
  });

  var qs = queryString(q);

  return p + (!!qs ? '?'+qs:'' );
}
